import { QueryKeyParam, createQueryKey } from 'core/Packages';

const entryKeys = () =>
  createQueryKey({
    all: ['ledger', 'entries'] as const,
    id: (providerId: QueryKeyParam) =>
      createQueryKey({
        all: ['ledger', 'entries', providerId] as const,
        detail: ['ledger', 'entries', providerId, 'detail'] as const,
      }),
  });

const ledgerKeys = createQueryKey({
  all: ['ledger'] as const,
  entries: entryKeys(),
});

export { ledgerKeys };
